import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { UtilService } from '../service/util.service';
import { ToastService } from '../service/toast.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  @Input() admins: any;

  @Output() deleteUsersEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() viewUserDetailEmitter: EventEmitter<any> = new EventEmitter<any>();

  selectedAdmins: Array<string> = new Array();
  loggedInUserId: string;

  constructor(public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    this.loggedInUserId = this.authService.loggedInUser.userId;
  }

  onAdminSelected(id: string) {
    console.log("admin id::", id);
    let itemIndex = this.selectedAdmins.indexOf(id);
    if (itemIndex !== -1) {
      this.selectedAdmins.splice(itemIndex, 1);
    } else {
      this.selectedAdmins.push(id);
    }
    console.log("selected admins::", this.selectedAdmins);
  }

  navigateToDetailPage(user) {
    console.log("Selected user : ", user);
    this.utilService.selectedAccountUser = user;
    this.viewUserDetailEmitter.emit();
  }

  cancelDeleteUser() {
    this.selectedAdmins = [];
    this.resetCheckbox();
  }

  resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  }
  
  onDeleteAdmins() {
    console.log("Received the request for delet admins::", this.selectedAdmins);
    if (this.selectedAdmins.length > 0) {
      this.deleteUsersEmitter.emit(JSON.parse(JSON.stringify(this.selectedAdmins)));
    } else {
      this.toast.showWarning("No user selected");
    }
  }

  onViewAdmin() {
    console.log("admin click for view");
  }

}
